"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACTOR_DISTANCE_KILO = exports.FACTOR_DISTANCE = exports.FACTOR_DISTANCE_MILLI = void 0;
/**
 * multiply milli distance in mm  by FACTOR_DISTANCE_MILLI to get the value in
 * in
 *
 *   DISTANCE l
 *     metric              imperial
 *
 *     mm              ->  in
 *     1 mm            =   0.03937 in
 *
 *     l[mm] * FACTOR_DISTANCE_MILLI = l[in]
 */
exports.FACTOR_DISTANCE_MILLI = 0.03937007;
/**
 * multiply distance in m by FACTOR_DISTANCE to get the value in ft
 *
 *   DISTANCE l
 *     metric              imperial
 *
 *     m               ->  ft
 *     1 m             =   3.28084 ft
 *
 *     l[m] * FACTOR_DISTANCE = l[ft]
 */
exports.FACTOR_DISTANCE = 3.28084;
/**
 * multiply kilo distance in km by FACTOR_DISTANCE_KILO to get the value in
 * miles
 *
 *   DISTANCE l
 *     metric              imperial
 *
 *     km              ->  miles
 *     1 km            =   0.621373 miles
 *
 *     l[km] * FACTOR_DISTANCE_KILO = l[miles]
 */
exports.FACTOR_DISTANCE_KILO = 0.621373;
//# sourceMappingURL=constants.js.map